import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {SearchQuery} query
     * @returns {Promise<void>}
     */
    async searchProductCategories (query) {
        try {
            const response = await http.get('/products/categories', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductQuery} data
     * @returns {Promise<void>}
     */
    async showProductCategory (data) {
        try {
            const response = await http.get(`/products/categories/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Category} data
     * @returns {Promise<void>}
     */
    async createProductCategory (data) {
        try {
            const response = await http.post('/products/categories', data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Category} data
     * @returns {Promise<void>}
     */
    async updateProductCategory (data) {
        try {
            const response = await http.put(`/products/categories/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {Category} data
     * @returns {Promise<void>}
     */
    async removeProductCategory (data) {
        try {
            const response = await http.delete(`/products/categories/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
